/** Playwright fixture tenants (`stepcare-e2e-seed`, `meta.fixture_set = 'e2e'`). */
export function isE2eFixtureTenant(tenant: {
  name?: string | null
  meta?: unknown
}): boolean {
  const name = (tenant.name ?? '').trim()
  if (name.startsWith('E2E ') || name.startsWith('[E2E]')) {
    return true
  }
  const meta = tenant.meta as { fixture_set?: string } | null | undefined
  return meta?.fixture_set === 'e2e'
}
